import React from 'react';
import { Field, ErrorMessage } from 'formik';

/**
 * Reusable RadioField Component
 * 
 * @param {string} name - Field name for Formik
 * @param {string} label - Display label
 * @param {Array} options - Array of {value, label} objects
 * @param {boolean} required - Whether field is required (default: true)
 * @param {string} colSize - Bootstrap column class (default: "col-md-6")
 * @param {Function} onChange - Custom onChange handler
 * @param {boolean} inline - Whether to display options inline (default: true)
 * @param {string} className - Additional CSS classes
 */
const RadioField = ({ 
  name, 
  label, 
  options = [
    { value: 'Present', label: 'Present' },
    { value: 'Absent', label: 'Absent' }
  ],
  required = true,
  colSize = "col-md-6",
  onChange,
  inline = true,
  className = "",
  ...props 
}) => {
  return (
    <div className={`${colSize} mt-3 ${className}`}>
      <div className="form-group radio-container d-flex align-items-center flex-wrap gap-3">
        <label className="control-label mb-0 label-left-text" style={{ whiteSpace: "nowrap" }}>
          {required && <span className="required-asterisk" style={{ color: "red", fontSize: "20px" }}>*</span>}
          {label}:
        </label>
        <div className={`radio-buttons ${inline ? 'd-flex align-items-center gap-3' : ''}`}>
          {options.map((opt, index) => (
            <div 
              key={opt.value} 
              className={`form-check ${inline ? 'form-check-inline mb-0' : ''} d-flex align-items-center gap-2`}
            >
              <Field 
                type="radio" 
                name={name} 
                value={opt.value}
                className="form-check-input m-0"
                id={`${name}-${opt.value}`}
                {...(onChange !== undefined && { onChange })}
                {...props}
              />
              <label 
                className="form-check-label mb-0" 
                htmlFor={`${name}-${opt.value}`}
                style={{ cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}
              >
                {opt.label}
              </label>
            </div>
          ))}
        </div>
        <ErrorMessage name={name} component="div" className="text-danger w-100" />
      </div>
    </div>
  );
};

export default RadioField;